<header-web (dataEvent)='setLanguage($event)'></header-web>
<section class="container px-md-5 px-1 pt-0 pb-5 mb-md-1 mb-5">
  <div class="row d-flex align-items-center">
    <div class="col-md-8 col-12 text-center">
      <div class="container">
        <h5 class="title fw-bold text-lago">¡Estamos aquí!</h5>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1153.2924627298087!2d-71.95981300508245!3d-13.523437842846024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x916dd5b70fed7f7b%3A0xfb7656238d665051!2sYACHAY%20ACPRODEC!5e0!3m2!1ses-419!2spe!4v1659538789972!5m2!1ses-419!2spe"
          class="mapa" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
    <div class="col-md-4 col-12 mx-auto text-center">
      <div class="container mx-auto">
        <h2 class="text-center title text-lago mb-4">CONTÁCTENOS</h2>
        <div class="mx-auto ps-5">
          <div class="d-flex align-items-center">
            <div class="flex-shrink-0 bg-contact">
              <img src="../../assets/image/recursos/contact-1.png" class="img-fluid" alt="...">
            </div>
            <div class="flex-grow-1 mt-2 ms-3 text-start">
              <p class="lh-sm subtitle text-rojo fw-bold"><small>Avenida la Cultura 1114,</small> <br> <small>4to. piso, oficina 402</small></p>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="flex-shrink-0 bg-contact">
              <img src="../../assets/image/recursos/contact-2.png" class="img-fluid" alt="...">
            </div>
            <div class="flex-grow-1 mt-2 ms-3 text-start">
              <p class="lh-sm subtitle text-rojo fw-bold"><small>ventas.facturacion@yachayacprodec.com</small> <br> <small>ventas@yachayacprodec.com</small></p>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="flex-shrink-0 bg-contact">
              <img src="../../assets/image/recursos/contact-3.png" class="img-fluid" alt="...">
            </div>
            <div class="flex-grow-1 mt-2 ms-3 text-start">
              <p class="lh-sm text-rojo fw-bold subtitle"><small>Celular: <a class="text-lago" target="_blank" href="https://wa.me/+51998883663?text=¡Estoy+interesado!">998 883663</a></small> <br> <small>Celular: <a class="text-lago" target="_blank" href="https://wa.me/+51996324395?text=¡Estoy+interesado!">996 324395</a></small></p>
              <!-- <br> <small>Teléfono: 084 - 597152</small> -->
            </div>
          </div>
        </div>
        <app-form-contact></app-form-contact>
      </div>
    </div>
  </div>
</section>
<footer-web class="mt-md-1 mt-5"></footer-web>
